import { render } from "./SendRecipesRecipeCard.vue?vue&type=template&id=367de73c"
import script from "./SendRecipesRecipeCard.vue?vue&type=script&lang=js"
export * from "./SendRecipesRecipeCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__